//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"DistanceTolerance",1,1],[0,"FoldedEdges",1,0],[0,"InconsistentNormals",1,0],[1,"InputBodies",0,"SelectDisplayableObjectList",0],[0,"LaminarSlits",1,0],[0,"LongFacets",1,0],[0,"MaxRatioLongFacets",1,0],[0,"MinAngleFoldedFacets",1,0],[0,"MinFacetNumberPerBody",1,0],[0,"OriginalBodyOption",1,0],[0,"SelfIntersections",1,0],[0,"ShowInfo",1,0],[0,"ThinFacets",1,0],[0,"ToleranceFactor",1,0]],[[[],"SetAllOptionsToNone",{},0,0],[[],"SetAllOptionsToAnalyze",{},0,0],[[],"SetAllOptionsToRepair",{},0,0],[[],"DisplayCleanupReportInListWindow",{},0,0]],[]];
SPLM.Facet.CleanupFacetBodyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.CleanupFacetBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.CleanupFacetBodyBuilder.CleanupOptions = Object.freeze({
    "None" : "None", "Analyze" : "Analyze", "Repair" : "Repair"});

SPLM.Facet.CleanupFacetBodyBuilder.OriginalBodyOptions = Object.freeze({
    "Keep" : "Keep", "Hide" : "Hide", "Delete" : "Delete"});

export default SPLM;